/* UMOJA About page: afro-modern pencil sketches (rough.js), drawn in the browser and traced as they come into view. */
(function(){
if(!window.rough) return;
const gen = rough.generator();

let seed = 7;
function S(cls, d, o = {}) { return { cls, d, o }; }

// Primitive builders: each returns a list of {cls, drawable}
function out(list, cls, drawable) { list.push({ cls, drawable }); }
function mk(scene) {
  const L = [];
  const base = { roughness: 1.15, bowing: 1.2, strokeWidth: 1, seed: 0 };
  const opt = (o) => Object.assign({}, base, { seed: ++seed }, o || {});
  const api = {
    line: (x1, y1, x2, y2, cls = 'ln', o) => out(L, cls, gen.line(x1, y1, x2, y2, opt(o))),
    rect: (x, y, w, h, cls = 'ln', o) => out(L, cls, gen.rectangle(x, y, w, h, opt(o))),
    ell: (cx, cy, w, h, cls = 'ln', o) => out(L, cls, gen.ellipse(cx, cy, w, h, opt(o))),
    arc: (cx, cy, w, h, a, b, cls = 'ln', o) => out(L, cls, gen.arc(cx, cy, w, h, a, b, false, opt(o))),
    path: (d, cls = 'ln', o) => out(L, cls, gen.path(d, opt(o))),
    poly: (pts, cls = 'ln', o) => out(L, cls, gen.polygon(pts, opt(o))),
    hatch: (d, gap = 6, angle = -41, cls = 'ht') => out(L, cls, gen.path(d, opt({ stroke: 'none', fill: '#000', fillStyle: 'hachure', hachureGap: gap, hachureAngle: angle, fillWeight: .6, roughness: 1.4 }))),
    cross: (d, gap = 7, cls = 'ht') => out(L, cls, gen.path(d, opt({ stroke: 'none', fill: '#000', fillStyle: 'cross-hatch', hachureGap: gap, fillWeight: .5, roughness: 1.3 }))),
  };
  scene(api);
  return L;
}

// Reusable afro-modern details
function mudcloth(a, x, y, w, h, cls = 'fn') {
  // bogolan rows: crosses, dots, zigzags, inside a cloth
  a.rect(x, y, w, h, 'ln');
  const rows = Math.floor(h / 12);
  for (let r = 0; r < rows; r++) {
    const yy = y + 7 + r * 12;
    if (yy > y + h - 4) break;
    if (r % 3 === 0) { let d = `M${x + 4} ${yy}`; for (let xx = x + 4; xx < x + w - 6; xx += 6) d += ` L${xx + 3} ${yy - 3} L${xx + 6} ${yy}`; a.path(d, cls, { roughness: .6 }); }
    else if (r % 3 === 1) { for (let xx = x + 6; xx < x + w - 4; xx += 9) { a.line(xx - 2, yy - 2, xx + 2, yy + 2, cls, { roughness: .4 }); a.line(xx + 2, yy - 2, xx - 2, yy + 2, cls, { roughness: .4 }); } }
    else { for (let xx = x + 8; xx < x + w - 4; xx += 10) a.ell(xx, yy, 2.2, 2.2, cls, { roughness: .3 }); }
  }
}
function basket(a, cx, cy, r, gold) {
  a.ell(cx, cy, r * 2, r * 2, gold ? 'au' : 'ln');
  a.ell(cx, cy, r * 1.4, r * 1.4, 'fn');
  a.ell(cx, cy, r * .7, r * .7, 'fn');
  for (let k = 0; k < 16; k++) { const t = k / 16 * Math.PI * 2; a.line(cx + Math.cos(t) * r * .38, cy + Math.sin(t) * r * .38, cx + Math.cos(t) * r * .96, cy + Math.sin(t) * r * .96, 'fn', { roughness: .5 }); }
}
function raffia(a, cx, top, w, h) {
  a.line(cx, 0, cx, top, 'ln', { roughness: .3 });
  a.path(`M${cx - w / 2} ${top + h} Q${cx - w / 2} ${top} ${cx} ${top} Q${cx + w / 2} ${top} ${cx + w / 2} ${top + h}`, 'au');
  a.hatch(`M${cx - w / 2} ${top + h} Q${cx - w / 2} ${top} ${cx} ${top} Q${cx + w / 2} ${top} ${cx + w / 2} ${top + h} Z`, 5, 90, 'ht');
  for (let x = cx - w / 2 + 2; x <= cx + w / 2 - 2; x += 4) a.line(x, top + h, x + (x - cx) * .05, top + h + 9 + Math.abs(Math.sin(x)) * 5, 'fn', { roughness: .4 });
}
function jar(a, cx, bottom, w, h, bands = true) {
  const t = bottom - h;
  a.path(`M${cx - w * .22} ${t} C${cx - w * .2} ${t + h * .15} ${cx - w * .5} ${t + h * .25} ${cx - w * .5} ${t + h * .55} C${cx - w * .5} ${t + h * .85} ${cx - w * .3} ${bottom} ${cx} ${bottom} C${cx + w * .3} ${bottom} ${cx + w * .5} ${t + h * .85} ${cx + w * .5} ${t + h * .55} C${cx + w * .5} ${t + h * .25} ${cx + w * .2} ${t + h * .15} ${cx + w * .22} ${t}`, 'ln');
  a.line(cx - w * .26, t, cx + w * .26, t, 'ln');
  if (bands) {
    a.path(`M${cx - w * .48} ${t + h * .45} Q${cx} ${t + h * .52} ${cx + w * .48} ${t + h * .45}`, 'fn');
    let d = `M${cx - w * .46} ${t + h * .52}`; for (let x = -w * .42; x < w * .46; x += w * .1) d += ` L${cx + x} ${t + h * (.6 + ((x / (w * .1)) % 2 ? .04 : 0))}`;
    a.path(d, 'fn', { roughness: .5 });
    a.hatch(`M${cx + w * .2} ${t + h * .2} C${cx + w * .5} ${t + h * .35} ${cx + w * .5} ${t + h * .8} ${cx + w * .2} ${bottom - 2} Z`, 4, -60);
  }
}
function palm(a, x, y, s, dir = 1) {
  a.path(`M${x} ${y} C${x + 2 * dir} ${y - 40 * s} ${x + 6 * dir} ${y - 80 * s} ${x + 10 * dir} ${y - 120 * s}`, 'ln');
  const leaves = [[-1, .55], [1, .7], [-1, .85], [1, 1]];
  for (const [side, k] of leaves) {
    const bx = x + 10 * dir * k, by = y - 120 * s * k;
    const tx = bx + side * 46 * s, ty = by - 30 * s;
    a.path(`M${bx} ${by} Q${bx + side * 20 * s} ${by - 34 * s} ${tx} ${ty} Q${bx + side * 30 * s} ${by - 4 * s} ${bx} ${by}`, 'ln');
    for (let i = 1; i < 6; i++) { const px = bx + (tx - bx) * i / 6, py = by + (ty - by) * i / 6 - 6 * s; a.line(px, py, px + side * 6 * s, py + 9 * s, 'fn', { roughness: .4 }); }
  }
}
function bronzeFigure(a, cx, base, h) {
  // elongated woman with a tall headwrap, in gold (bronze)
  const k = h / 160, X = (v) => cx + v * k, Y = (v) => base - h + v * k;
  a.path(`M${X(-6)} ${Y(30)} C${X(-14)} ${Y(14)} ${X(-6)} ${Y(-2)} ${X(6)} ${Y(0)} C${X(18)} ${Y(4)} ${X(16)} ${Y(22)} ${X(8)} ${Y(30)}`, 'au');
  a.ell(X(1), Y(38), 16 * k, 20 * k, 'au');
  a.line(X(-2), Y(48), X(-2), Y(60), 'au'); a.line(X(4), Y(48), X(4), Y(60), 'au');
  for (let i = 0; i < 3; i++) a.line(X(-5), Y(51 + i * 3), X(7), Y(51 + i * 3), 'au', { roughness: .3 });
  a.path(`M${X(-9)} ${Y(62)} C${X(-16)} ${Y(90)} ${X(-12)} ${Y(118)} ${X(-6)} ${Y(140)} C${X(-4)} ${Y(150)} ${X(-10)} ${Y(156)} ${X(-14)} ${Y(160)} L${X(18)} ${Y(160)} C${X(12)} ${Y(154)} ${X(10)} ${Y(146)} ${X(12)} ${Y(134)} C${X(18)} ${Y(108)} ${X(18)} ${Y(84)} ${X(12)} ${Y(62)} Z`, 'au');
  a.hatch(`M${X(4)} ${Y(64)} C${X(14)} ${Y(86)} ${X(14)} ${Y(110)} ${X(9)} ${Y(134)} C${X(8)} ${Y(146)} ${X(10)} ${Y(154)} ${X(14)} ${Y(158)} L${X(4)} ${Y(158)} Z`, 3, -50, 'ha');
}
function stoolBamileke(a, cx, top, bottom, w) {
  a.ell(cx, top, w, 12, 'ln'); a.ell(cx, bottom, w * .94, 10, 'ln');
  a.line(cx - w / 2, top, cx - w * .47, bottom, 'ln'); a.line(cx + w / 2, top, cx + w * .47, bottom, 'ln');
  const n = 6, step = w / n;
  for (let i = 0; i < n; i++) {
    const x = cx - w / 2 + step * i + step / 2, my = (top + bottom) / 2, hh = (bottom - top) / 2 - 6;
    a.poly([[x, my - hh], [x + step / 2 - 2, my], [x, my + hh], [x - step / 2 + 2, my]], 'fn', { roughness: .5 });
  }
  a.hatch(`M${cx + w * .1} ${top + 6} L${cx + w / 2} ${top} L${cx + w * .47} ${bottom} L${cx + w * .1} ${bottom + 4} Z`, 4, -60);
}
function kenteRug(a, y1, y2, x1, x2, inset) {
  a.poly([[x1 + inset, y1], [x2 - inset, y1], [x2, y2], [x1, y2]], 'ln');
  for (let i = 1; i < 9; i++) { const t = i / 9; a.line(x1 + inset + (x2 - x1 - 2 * inset) * t, y1, x1 + (x2 - x1) * t, y2, 'fn', { roughness: .5 }); }
  const my = (y1 + y2) / 2; let d = `M${x1 + inset / 2} ${my}`; for (let x = x1 + inset / 2; x < x2 - inset / 2; x += 10) d += ` L${x + 5} ${my - 4} L${x + 10} ${my}`; a.path(d, 'au', { roughness: .6, strokeWidth: .8 });
}
function frame(a, x, y, w, h, gold) { a.rect(x, y, w, h, gold ? 'au' : 'ln'); a.rect(x + 7, y + 7, w - 14, h - 14, 'fn'); }
function portrait(a, x, y, w, h) {
  // woman in profile with headwrap, inside a painting
  const X = (v) => x + v * w / 100, Y = (v) => y + v * h / 120;
  a.path(`M${X(52)} ${Y(30)} C${X(40)} ${Y(14)} ${X(56)} ${Y(4)} ${X(70)} ${Y(12)} C${X(80)} ${Y(18)} ${X(76)} ${Y(32)} ${X(66)} ${Y(36)}`, 'ln');
  a.path(`M${X(52)} ${Y(30)} C${X(44)} ${Y(38)} ${X(42)} ${Y(46)} ${X(44)} ${Y(52)} L${X(40)} ${Y(58)} L${X(45)} ${Y(60)} C${X(44)} ${Y(66)} ${X(48)} ${Y(70)} ${X(54)} ${Y(70)} L${X(56)} ${Y(84)}`, 'ln');
  a.path(`M${X(66)} ${Y(36)} C${X(70)} ${Y(50)} ${X(66)} ${Y(64)} ${X(66)} ${Y(84)}`, 'ln');
  a.path(`M${X(40)} ${Y(120)} C${X(40)} ${Y(96)} ${X(50)} ${Y(86)} ${X(60)} ${Y(84)} C${X(76)} ${Y(86)} ${X(88)} ${Y(98)} ${X(90)} ${Y(120)}`, 'ln');
  a.hatch(`M${X(8)} ${Y(8)} L${X(40)} ${Y(8)} L${X(44)} ${Y(112)} L${X(8)} ${Y(112)} Z`, 5, -45);
  a.arc(X(80), Y(30), w * .24, w * .24, Math.PI * 1.1, Math.PI * 1.9, 'au');
}
function ladder(a, x, top, bottom) {
  a.path(`M${x - 6} ${bottom} C${x} ${top + 140} ${x + 4} ${top + 50} ${x - 2} ${top + 6} L${x + 6} ${top - 10} L${x + 14} ${top + 4} L${x + 24} ${top - 10} L${x + 30} ${top + 6} C${x + 28} ${top + 50} ${x + 30} ${top + 140} ${x + 36} ${bottom}`, 'ln');
  for (let yy = top + 34; yy < bottom - 14; yy += 32) { a.path(`M${x + 1} ${yy} L${x + 15} ${yy - 12} L${x + 31} ${yy}`, 'ln', { roughness: .5 }); a.hatch(`M${x + 3} ${yy} L${x + 15} ${yy - 10} L${x + 29} ${yy} Z`, 2.5, 0); }
  a.hatch(`M${x + 18} ${top} L${x + 30} ${top + 6} C${x + 28} ${top + 50} ${x + 30} ${top + 140} ${x + 36} ${bottom} L${x + 18} ${bottom} Z`, 4, -60);
}
function wallTexture(a, n, x1, y1, x2, y2) { for (let i = 0; i < n; i++) { const x = x1 + ((i * 73) % (x2 - x1)), y = y1 + ((i * 131) % (y2 - y1)); a.line(x, y, x + 6 + (i % 4), y + ((i % 3) - 1), 'tx', { roughness: .8 }); } }

const scenes = {
  spaces: (a) => {
    wallTexture(a, 40, 20, 20, 380, 300);
    a.line(14, 420, 386, 420);
    a.path('M70 420 V180 A130 130 0 0 1 330 180 V420');
    a.path('M82 420 V182 A118 118 0 0 1 318 182 V420', 'fn');
    a.hatch('M82 420 V182 A118 118 0 0 1 318 182 V300 L82 300 Z', 9, -35, 'ht2');
    raffia(a, 200, 52, 92, 36);
    basket(a, 136, 176, 26, false); basket(a, 202, 158, 34, true); basket(a, 266, 182, 22, false);
    a.path('M56 336 c0-8 6-12 14-12 h260 c8 0 14 4 14 12 v46 H56 Z');
    a.path('M66 324 v-30 c0-6 4-10 10-10 h112 c6 0 10 4 10 10 v30 M202 324 v-30 c0-6 4-10 10-10 h112 c6 0 10 4 10 10 v30');
    a.hatch('M56 368 H344 V382 H56 Z', 4, -50);
    mudcloth(a, 92, 294, 42, 40); mudcloth(a, 266, 296, 42, 40);
    a.line(68, 382, 70, 420); a.line(332, 382, 330, 420);
    stoolBamileke(a, 200, 392, 418, 70);
    jar(a, 200, 392, 26, 22, false);
    jar(a, 40, 420, 46, 56); palm(a, 40, 366, 1.05, 1);
    jar(a, 362, 420, 30, 64);
    kenteRug(a, 428, 470, 34, 366, 40);
  },
  art: (a) => {
    wallTexture(a, 36, 20, 20, 380, 300);
    a.line(14, 420, 386, 420);
    a.path('M232 0 L188 296 M232 0 L276 296', 'gl');
    frame(a, 26, 88, 146, 196); portrait(a, 33, 95, 132, 182);
    a.path('M180 296 h104 v124 h-104 Z'); a.path('M172 288 h120 v8 h-120 Z');
    a.hatch('M246 300 h38 v120 h-38 Z', 5, -45);
    bronzeFigure(a, 232, 288, 150);
    ladder(a, 326, 104, 420);
    jar(a, 118, 420, 50, 70); jar(a, 158, 420, 32, 44);
    a.line(30, 446, 370, 446, 'fn');
  },
  home: (a) => {
    wallTexture(a, 34, 20, 20, 380, 300);
    a.line(14, 420, 386, 420);
    a.rect(34, 64, 128, 196); a.line(98, 64, 98, 260, 'fn'); a.line(34, 162, 162, 162, 'fn');
    a.hatch('M40 70 L156 70 L156 256 L40 256 Z', 10, -55, 'ht2');
    a.path('M24 54 H174'); a.path('M28 54 C38 120 40 200 30 290', 'fn'); a.path('M170 54 C160 120 158 200 168 290', 'fn');
    a.line(214, 70, 334, 70); mudcloth(a, 222, 74, 104, 118);
    a.path('M108 400 c-8-64 4-108 34-128 c28-18 70-16 92 6 c22 22 26 70 18 122 z');
    a.path('M108 400 h144'); a.path('M118 336 c34-8 100-8 130 2');
    a.path('M200 282 c18 2 34 8 42 18 l-14 96 c-12 2-26 0-38-4 c6-34 12-70 10-110 z', 'au');
    a.hatch('M200 282 c18 2 34 8 42 18 l-14 96 c-12 2-26 0-38-4 c6-34 12-70 10-110 z', 4, -60, 'ha');
    for (let y = 300; y < 388; y += 14) a.line(206, y, 234, y + 4, 'au', { strokeWidth: .7, roughness: .5 });
    a.line(118, 400, 112, 420); a.line(246, 400, 252, 420);
    a.path('M280 420 h56 M288 420 c8-10 8-30 2-46 h36 c-6 16-6 36 2 46 M282 374 c10 6 42 6 52 0 l-4-8 h-44 z');
    a.rect(292, 352, 34, 6, 'fn'); a.rect(294, 346, 30, 6, 'fn');
    a.path('M318 346 c-4-10-2-24 6-30 c6 8 6 22 2 30', 'ln');
    a.path('M322 316 c-6-20-16-34-28-42 M322 316 c4-22 14-36 26-44 M322 316 c-2-24 2-40 10-52', 'fn');
    a.line(372, 420, 372, 236); a.line(360, 420, 384, 420);
    a.path('M372 236 c-14-2-26-8-32-18', 'au'); a.path('M322 222 q16-20 34 0 z', 'au');
    kenteRug(a, 428, 470, 40, 360, 36);
  },
  hospitality: (a) => {
    wallTexture(a, 30, 20, 20, 380, 300);
    a.line(10, 420, 390, 420);
    for (const [x1, x2, top] of [[22, 124, 180], [149, 251, 150], [276, 378, 180]]) {
      const r = (x2 - x1) / 2; a.path(`M${x1} 420 V${top} A${r} ${r} 0 0 1 ${x2} ${top} V420`);
      a.path(`M${x1 + 12} 420 V${top + 2} A${r - 12} ${r - 12} 0 0 1 ${x2 - 12} ${top + 2} V420`, 'fn');
      a.hatch(`M${x1 + 12} 330 V${top + 2} A${r - 12} ${r - 12} 0 0 1 ${x2 - 12} ${top + 2} V330 Z`, 10, -35, 'ht2');
    }
    raffia(a, 136, 70, 58, 26); raffia(a, 264, 70, 58, 26);
    a.path('M96 420 V346 c0-8 6-12 14-12 h180 c8 0 14 4 14 12 V420');
    a.line(88, 334, 312, 334, 'au');
    for (let x = 108; x < 296; x += 22) { a.poly([[x, 350], [x + 11, 368], [x, 386], [x - 11, 368]], 'fn', { roughness: .5 }); a.line(x, 390, x, 414, 'fn', { roughness: .4 }); }
    a.hatch('M240 346 h50 v74 h-50 Z', 5, -45);
    bronzeFigure(a, 270, 334, 56);
    jar(a, 200, 334, 22, 18, false);
    jar(a, 40, 420, 50, 64); palm(a, 40, 358, 1.05, 1);
    jar(a, 360, 420, 50, 64); palm(a, 360, 358, 1.05, -1);
    a.line(30, 446, 370, 446, 'fn');
  },
  collectors: (a) => {
    wallTexture(a, 34, 20, 20, 380, 300);
    a.line(14, 420, 386, 420);
    frame(a, 30, 96, 128, 168); portrait(a, 37, 103, 114, 154);
    frame(a, 172, 96, 96, 72); mudcloth(a, 180, 104, 80, 56);
    frame(a, 172, 182, 96, 82); a.arc(220, 246, 46, 46, Math.PI, Math.PI * 2, 'au'); a.line(182, 246, 258, 246, 'fn');
    frame(a, 282, 96, 86, 120, true); a.hatch('M290 104 h70 v104 h-70 Z', 6, 45);
    a.path('M70 88 h48 M94 88 v-8 M196 88 h48 M220 88 v-8', 'au');
    a.path('M74 90 L54 150 M114 90 L134 150 M200 90 L186 126 M240 90 L254 126', 'gl');
    a.path('M70 340 h180 M80 340 v80 M240 340 v80 M74 332 h172', 'ln'); a.hatch('M80 344 h160 v8 h-160 Z', 3, -45);
    a.path('M292 420 V310 h56 V420 M286 310 h68', 'ln'); a.hatch('M330 314 h18 v106 h-18 Z', 5, -45);
    // bronze head, Ife inspired, on the plinth
    bronzeFigure(a, 320, 310, 118);
    a.line(30, 446, 370, 446, 'fn');
  },
};


const NS='http://www.w3.org/2000/svg', GLOW={spaces:[200,150],art:[232,230],home:[330,150],hospitality:[200,190],collectors:[150,180]};
document.querySelectorAll('[data-usk]').forEach(function(f){
  const k=f.getAttribute('data-usk'); if(!scenes[k]) return;
  seed=7; const L=mk(scenes[k]);
  const svg=document.createElementNS(NS,'svg'); svg.setAttribute('viewBox','0 0 400 500'); svg.setAttribute('aria-hidden','true');
  const g=GLOW[k]; svg.innerHTML='<defs><radialGradient id="ug'+k+'" cx="'+g[0]+'" cy="'+g[1]+'" r="140" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#d8b27a" stop-opacity=".22"/><stop offset="1" stop-color="#d8b27a" stop-opacity="0"/></radialGradient></defs><circle class="glow" cx="'+g[0]+'" cy="'+g[1]+'" r="140" fill="url(#ug'+k+')"/>';
  L.forEach(function(it){ gen.toPaths(it.drawable).forEach(function(p){ const e=document.createElementNS(NS,'path'); e.setAttribute('class',it.cls); e.setAttribute('d',p.d); svg.appendChild(e); }); });
  f.appendChild(svg);
  const ps=[].slice.call(svg.querySelectorAll('path')), n=ps.length;
  ps.forEach(function(p,i){ try{ p.style.setProperty('--len', Math.ceil(p.getTotalLength())+1); }catch(e){} p.style.setProperty('--d',(i/n*3).toFixed(2)+'s'); });
  if(!('IntersectionObserver' in window)){ f.classList.add('in'); return; }
  new IntersectionObserver(function(es,o){ if(es[0].isIntersecting){ f.classList.add('in'); o.disconnect(); } },{threshold:.35}).observe(f);
});
})();
